import { render, staticRenderFns } from "./OeSentenceManage.vue?vue&type=template&id=42a353e4&scoped=true&"
import script from "./OeSentenceManage.vue?vue&type=script&lang=js&"
export * from "./OeSentenceManage.vue?vue&type=script&lang=js&"
import style0 from "./OeSentenceManage.vue?vue&type=style&index=0&id=42a353e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a353e4",
  null
  
)

export default component.exports